module.exports = __webpack_public_path__ + "img/bar-code.f00f2853.svg";